import { BASE_SCHEMA } from '@/shared/converters/baseConverters';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import PaymentStatus from '../constants/PaymentStatus';
import PaymentRequest from '../models/PaymentRequest';

const REQUEST_SCHEMA = {
  ...BASE_SCHEMA,
  amount: 'amount',
  reference: 'reference',
  attachment: 'attachment',
  status: (data: any) => (data.status === 'NOT_PAID' ? PaymentStatus.OPEN : data.status),
  targets: (data: any) => data.sentTo.split(','),
};

export function parsePaymentRequest(data: any): PaymentRequest | null {
  return parseEntity(data, REQUEST_SCHEMA, PaymentRequest);
}

export function parsePaymentRequests(data: any): Array<PaymentRequest> {
  return parseEntities(data, parsePaymentRequest);
}
